import ThreadPostbox from './ThreadPostbox';
import ThreadPostboxContainer from './ThreadPostbox.container';
export default ThreadPostboxContainer(ThreadPostbox);
